import React, { useEffect, useState } from "react"
import { Col, Container, Modal, Row } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { parsedUser } from "../../../common/GetCurrentUser"
import API from "../../../common/API"
import EmployeAddEdit from "../../Employees/EmployeAddEdit"
import LaborAccessRequestDTO from "../LaborAccessRequestDTO"
import FieldSelector from "../../core/FieldSelector"
import CRUDField from "../../core/genericCRUD/CRUDField"
import CRUD from "../../core/genericCRUD/CRUD"
import VehicleFieldsDTO from "../VehicleFieldsDTO"

const EmployeeValidation = props => {
  const { t } = useTranslation("global")
  const user = parsedUser()
  const vehicleFields: CRUDField[] = VehicleFieldsDTO
  const [record, setRecord] = useState<any>(null)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [records, setRecords] = useState<any>([])
  const [search, setSearch] = useState<string>("")
  const [showAddEditEmployee, setShowAddEditEmployee] = useState<boolean>(false)
  const [selectedEmployee, setSelectedEmployee] = useState<any>(null)
  const fields: CRUDField[] = LaborAccessRequestDTO

  const toggleAddEdit = item => {
    setSelectedEmployee(item)
    setShowAddEditEmployee(!showAddEditEmployee)
  }
  const getRecords = async () => {
    try {
      let query = "laborAccessRequestId=" + props.record.id;
      setIsLoading(true)
      let request = await API.getAction("laborAccessRequest/getEmployees?" + query)

      setRecords(request.data.response)
      console.log("request remote")
    } catch (e) {
      console.error(e)
    } finally {
      setIsLoading(false)
    }
  }
  const toggleAddEditEmployee = () => {
    setShowAddEditEmployee(!showAddEditEmployee)
    if (showAddEditEmployee) {
      getRecords()
    }
  }

  const approveOrDeny = async (item: any, approve: boolean) => {

    let request = await API.getAction(
      `laborAccessRequest/AproveEmployee?laborAccessRequestEmployeeId=${item.id}&approve=${approve}`
    )

    getRecords();
  }
  const bindDataDetails = async () => {
    const request = await API.getAction("laborAccessRequest/Details?id=" + props.record.id)
    if (request.data.status === "ok") {
      setRecord(request.data.response)
    }
  }

  useEffect(() => {
    getRecords()
  }, [])
  useEffect(() => {
    bindDataDetails();
  }, [props.record])

  return (
    <>
      {showAddEditEmployee && (
        <EmployeAddEdit
          cssClass="modalRight"
          title="Empleado"
          toggle={toggleAddEditEmployee}
          laborAccessRequestId={props.record.id}
          record={selectedEmployee}
        />
      )}
      <Modal
        show={true}
        onHide={props.toggle}
        size={props.modalSize ? props.modalSize : "lg"}
        className={props.cssClass + " modalRight"}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {t("Solicitud de acceso laboral")}


          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Row>
              {record && fields &&
                fields
                  .filter(x => x.htmlType !== "hidden")
                  .map((item, index) => {
                    return (
                      <FieldSelector
                        key={index}
                        model={{
                          ...item,
                          readOnly: true,
                        }}

                        obj={record}
                        value={
                          record[item.name as keyof typeof record]
                        }
                      // errors={formik.errors}
                      />
                    )
                  })}
              <Col xs={12}>
                <h4 className="mt-4">{t("Empleados") ?? ""}</h4>
                <hr />
                <table className="table table-striped table-bordered mt-4">
                  <thead>
                    <tr>
                      <th></th>
                      <th>{t("Nombre")}</th>

                      <th>{t("Employment Type")}</th>
                      <th></th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {records &&
                      records.map((item, index) => {
                        return (
                          <tr key={index}>
                            <td></td>
                            <td>{item.firstName} {item.lastName}</td>

                            <td>{item.employeeTypeName}</td>
                            <td className="text-end">
                              <div className="btn-group">
                                {item.approved !== true &&
                                  <button className="btn btn-sm btn-success "
                                    onClick={() => approveOrDeny(item, true)}>
                                    <span className="fa fa-thumbs-up me-2"></span>{" "}
                                    Aprobar
                                  </button>}
                                {item.approved !== false &&
                                  <button className="btn btn-sm btn-danger "
                                    onClick={() => approveOrDeny(item, false)}>
                                    <span className="fa fa-thumbs-down me-2"></span>{" "}
                                    Denegar
                                  </button>}
                              </div>
                            </td>
                            <td className="text-center">
                              <button className="btn btn-sm btn-primary "
                                onClick={() => toggleAddEdit(item)}>

                                <i className="fa fa-edit" />
                              </button>
                            </td>
                          </tr>
                        )
                      })}
                  </tbody>
                </table>
              </Col>

              <Col xs={12} className="my-4 px-0 mx-0">
                <CRUD
                  fields={vehicleFields}
                  isModal={false}
                  id="vehicleForm"
                  headerStyle={"justButtons"}
                  // modalSize="sm"
                  cssClass="modalRight"
                  filterOpen={false}
                  readOnly={true}

                  // showModal={props.show}
                  // toggleCRUD={props.toggle}
                  title={t("Vehiculo de transporte laboral ") ?? ""}
                  // icon={"fas fa-building"}
                  parentId="laborAccessRequestId"
                  parentValue={props.record.id}
                  getRecordsMethod="post"
                  getRecordsPath={`laborAccessRequestVehicle/list`}
                  addEditRecordPath={`laborAccessRequestVehicle/AddEdit`}
                  deleteRecordPath="laborAccessRequestVehicle/Delete"
                  fieldsList={[
                    {
                      name: "driverName",
                      title: t("Conductor"),
                      htmlType: "text",
                    },
                    {
                      name: "driverLicense",
                      title: t("Licencia"),
                      htmlType: "text",
                    },
                    {
                      name: "vehiclePlate",
                      title: t("Placa"),
                      htmlType: "text",
                    },
                    {
                      name: "insurancePolicyNumber",
                      title: t("No. de poliza de seguro"),
                      htmlType: "text",
                    },
                  ]}
                />
              </Col>
            </Row>
          </Container>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default EmployeeValidation
